<template>
  <Teleport to="body">
    <div 
      class="modal fade" 
      id="sectionSelectorModal" 
      data-bs-backdrop="static" 
      data-bs-keyboard="false" 
      tabindex="-1" 
      aria-labelledby="sectionSelectorModalLabel" 
      aria-hidden="true"
      ref="modalElement"
    >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="sectionSelectorModalLabel">انتخاب محیط</h5>
          <button 
            type="button" 
            class="btn-close" 
            @click="closeModal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <!-- Businesses Section -->
          <div v-for="business in businesses" :key="business.id" class="mb-4 business-section">
            <!-- Business Header -->
            <div class="business-header mb-3">
              <h6 class="mb-0 fw-semibold d-flex align-items-center">
                <i class="ri-building-2-line me-2"></i>
                {{ business.name }}
              </h6>
            </div>
            
            <!-- Branches -->
            <div class="mb-3">
              <h6 class="mb-2 fw-normal text-muted small">شعبه</h6>
              <div class="branch-list">
                <button 
                  v-for="branch in business.branches"
                  :key="branch.id"
                  :class="['btn', 'w-100', 'mb-2', 'branch-item', { 
                    'btn-soft-primary': branch.active, 
                    'btn-soft-secondary': !branch.active,
                    'active': branch.active
                  }]"
                  type="button"
                  @click="selectItem(branch.id)"
                >
                  <div class="d-flex align-items-center justify-content-between">
                    <span>{{ branch.name }}</span>
                    <i :class="['ri-check-line', { 'd-none': !branch.active }]"></i>
                  </div>
                </button>
                <button 
                  type="button" 
                  class="btn btn-outline-primary w-100 add-branch-btn mt-2"
                  @click="handleAddBranch"
                >
                  <i class="ri-add-line me-2"></i>
                  اضافه کردن شعبه
                </button>
              </div>
            </div>
            
            <!-- Accounting and CRM -->
            <div class="mb-3">
              <h6 class="mb-2 fw-normal text-muted small">سایر بخش‌ها</h6>
              <div class="branch-list">
                <!-- Accounting -->
                <button 
                  :class="['btn', 'w-100', 'mb-2', 'branch-item', { 
                    'btn-soft-primary': business.accounting.active, 
                    'btn-soft-secondary': !business.accounting.active,
                    'active': business.accounting.active
                  }]"
                  type="button"
                  @click="selectItem(business.accounting.id)"
                >
                  <div class="d-flex align-items-center justify-content-between">
                    <span>{{ business.accounting.name }}</span>
                    <i :class="['ri-check-line', { 'd-none': !business.accounting.active }]"></i>
                  </div>
                </button>
                <!-- CRM -->
                <button 
                  :class="['btn', 'w-100', 'mb-2', 'branch-item', { 
                    'btn-soft-primary': business.crm.active, 
                    'btn-soft-secondary': !business.crm.active,
                    'active': business.crm.active
                  }]"
                  type="button"
                  @click="selectItem(business.crm.id)"
                >
                  <div class="d-flex align-items-center justify-content-between">
                    <span>{{ business.crm.name }}</span>
                    <i :class="['ri-check-line', { 'd-none': !business.crm.active }]"></i>
                  </div>
                </button>
              </div>
            </div>
          </div>
          
          <!-- Add New Business Button -->
          <div class="mt-4 pt-3 border-top">
            <button 
              type="button" 
              class="btn btn-outline-primary w-100 add-business-btn"
              :disabled="true"
              @click="handleAddBusiness"
            >
              <i class="ri-add-line me-2"></i>
              اضافه کردن کسب و کار جدید
            </button>
          </div>
        </div>
        <div class="modal-footer">
          <button 
            type="button" 
            class="btn btn-secondary" 
            @click="closeModal"
          >
            بستن
          </button>
        </div>
      </div>
    </div>
    </div>
  </Teleport>
</template>

<script>
import { Modal } from 'bootstrap'

export default {
  name: 'SectionSelectorModal',
  props: {
    businesses: {
      type: Array,
      required: true
    }
  },
  emits: ['item-selected'],
  setup(props, { emit }) {
    // Select item (branch, accounting, or CRM)
    const selectItem = (itemId) => {
      emit('item-selected', itemId)
    }

    // Handle add branch button
    const handleAddBranch = () => {
      // TODO: Implement add branch functionality
      alert('قابلیت اضافه کردن شعبه به زودی اضافه خواهد شد')
    }

    // Handle add business button
    const handleAddBusiness = () => {
      alert('بزودی')
    }

    // Close modal
    const closeModal = () => {
      const modalElement = document.getElementById('sectionSelectorModal')
      if (modalElement) {
        const modalInstance = Modal.getInstance(modalElement)
        if (modalInstance) {
          modalInstance.hide()
        }
      }
    }

    return {
      selectItem,
      handleAddBranch,
      handleAddBusiness,
      closeModal
    }
  }
}
</script>

<style>
/* Ensure modal is above backdrop - global styles needed since modal is rendered at body level */
#sectionSelectorModal {
  z-index: 1055 !important;
  position: fixed !important;
}

#sectionSelectorModal.show {
  display: block !important;
}

#sectionSelectorModal .modal-dialog {
  z-index: 1056;
  position: relative;
  pointer-events: auto;
}

#sectionSelectorModal .modal-content {
  z-index: 1057;
  position: relative;
  pointer-events: auto;
}

/* Ensure backdrop is below modal and doesn't block interactions */
.modal-backdrop {
  z-index: 1050 !important;
  pointer-events: auto;
}

/* Ensure modal content is clickable */
#sectionSelectorModal .modal-content * {
  pointer-events: auto;
}
</style>

<style scoped>
.business-section {
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  padding-bottom: 1.5rem;
}

.business-section:last-child {
  border-bottom: none;
  padding-bottom: 0;
}

.business-header {
  padding-bottom: 0.5rem;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  margin-bottom: 1rem;
}

.business-header h6 {
  color: var(--bs-primary);
  font-size: 1rem;
}

.branch-item {
  text-align: right;
  transition: all 0.2s ease;
  border: 1px solid transparent;
}

.branch-item:hover {
  transform: translateX(-3px);
  border-color: var(--bs-primary);
}

.branch-item.active {
  background-color: var(--bs-primary);
  color: white;
  border-color: var(--bs-primary);
}

.branch-item.active .ri-check-line {
  display: inline-block !important;
}

/* Improve Farmanieh branch color in dark mode */
html[data-bs-theme="dark"] .branch-item.btn-soft-secondary {
  --bs-btn-color: #a8b2b5;
  --bs-btn-bg: rgba(168, 178, 181, 0.15);
  --bs-btn-hover-color: #ffffff;
  --bs-btn-hover-bg: rgba(168, 178, 181, 0.25);
  --bs-btn-hover-border-color: rgba(168, 178, 181, 0.3);
}

html[data-bs-theme="dark"] .branch-item.btn-soft-secondary:hover {
  background-color: rgba(168, 178, 181, 0.25);
  color: #ffffff;
  border-color: rgba(168, 178, 181, 0.3);
}

.add-branch-btn {
  font-weight: 500;
  transition: all 0.2s ease;
  border-style: dashed !important;
  border-width: 2px;
}

.add-branch-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  background-color: rgba(var(--bs-primary-rgb), 0.1);
  color: var(--bs-primary);
  border-color: var(--bs-primary);
  border-style: dashed !important;
}

.add-branch-btn:active,
.add-branch-btn:focus {
  border-style: dashed !important;
  border-color: var(--bs-primary);
}

/* Dark mode improvements for add branch button */
html[data-bs-theme="dark"] .add-branch-btn {
  color: #a8b2b5;
  border-color: rgba(168, 178, 181, 0.5);
  background-color: transparent;
}

html[data-bs-theme="dark"] .add-branch-btn:hover {
  color: var(--bs-primary);
  border-color: var(--bs-primary);
  background-color: rgba(var(--bs-primary-rgb), 0.15);
  border-style: dashed !important;
}

.add-business-btn {
  font-weight: 500;
  transition: all 0.2s ease;
  border-style: dashed !important;
  border-width: 2px;
  cursor: not-allowed;
  opacity: 0.6;
}

.add-business-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  background-color: rgba(var(--bs-primary-rgb), 0.1);
  color: var(--bs-primary);
  border-color: var(--bs-primary);
  border-style: dashed !important;
  opacity: 0.8;
}

.add-business-btn:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.add-business-btn:disabled:hover {
  opacity: 0.6;
}

/* Dark mode improvements for add business button */
html[data-bs-theme="dark"] .add-business-btn {
  color: #a8b2b5;
  border-color: rgba(168, 178, 181, 0.5);
  background-color: transparent;
}

html[data-bs-theme="dark"] .add-business-btn:hover {
  color: var(--bs-primary);
  border-color: var(--bs-primary);
  background-color: rgba(var(--bs-primary-rgb), 0.15);
  border-style: dashed !important;
}

html[data-bs-theme="dark"] .add-business-btn:disabled {
  opacity: 0.6;
}

html[data-bs-theme="dark"] .add-business-btn:disabled:hover {
  opacity: 0.6;
}
</style>

